$(document).ready(function () {
    ConfigureDataTable();

    try {
        // RefreshDataTables();
    } catch (e) { }
    // Full Story User Identification
   /* FS.identify($('#FSuserId').val(), {
        displayName: $('#FSdisplayName').val(),
        email: $('#FSemail').val()
    });*/
});

function ConfigureDataTable() {
    if ($('.wbe-data-table').DataTable !== undefined) {
        $('.wbe-data-table').DataTable({
            responsive: true,
            stateSave: true,
            stateDuration: -1,//use session storage
            pageLength: 25,
            deferRender: true,
            columnDefs: [
                {
                    targets: 'timestamp',
                    render: DataTable.render.datetime("MM/DD/YYYY HH:mm"),
                    className: 'dt-head-left dt-body-left'
                },
                { orderable: false, targets: 'col-action-btn' },
                { responsivePriority: 2, targets: 'col-action-btn' }
            ],
            buttons:
                [
                    { extend: 'copy', className: 'btn-primary' },
                    { extend: 'csv', className: 'btn-primary ' },
                    { extend: 'pdf', className: 'btn-primary' },
                ],
            layout: {
                topEnd: ['search', 'buttons']
            }          
        });
    }
}


function ShowPageLoadingSpinner() {
    swal({
        title: "Loading...",
        text: "Please wait while the page is loading.",
        icon: "https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/0.16.1/images/loader-large.gif",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false
    });
}

function ShowProcessingSpinner(message) {
    swal({
        title: "Processing...",
        text: message || "Please wait while your request is being processed.",
        icon: "https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/0.16.1/images/loader-large.gif",
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false
    });
}